"use client";
import * as React from "react";
const SvgRouteOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.22 10.83V3.56A3.56 3.56 0 0 0 10.67 0 3.56 3.56 0 0 0 7.1 3.56v8.88a1.78 1.78 0 0 1-3.55 0V5.17a2.7 2.7 0 0 0 1.77-2.5A2.66 2.66 0 0 0 2.67 0 2.66 2.66 0 0 0 0 2.67c0 1.15.75 2.13 1.78 2.5v7.27A3.56 3.56 0 0 0 5.33 16a3.56 3.56 0 0 0 3.56-3.56V3.56a1.78 1.78 0 0 1 3.56 0v7.27a2.66 2.66 0 0 0 .88 5.17A2.66 2.66 0 0 0 16 13.33c0-1.15-.75-2.13-1.78-2.5M2.67 3.56a.9.9 0 0 1-.9-.9.9.9 0 0 1 1.79 0 .9.9 0 0 1-.9.9m10.66 10.66a.9.9 0 0 1-.89-.89.9.9 0 1 1 1.78.01.9.9 0 0 1-.89.88" }));
export {
  SvgRouteOutlined as default
};
